var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('Music',{attrs:{"active":_vm.isMusic},on:{"click":_vm.onclick}}),_c('a',{staticClass:"home-btn",attrs:{"href":"http://www.0531yun.com/ksh.html","target":"_blank"}},[_c('img',{attrs:{"src":require('@/assets/home.png'),"alt":""}})]),_c('CustomPano',{ref:"pano"}),_c('CustomTabBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }